module.exports = __webpack_public_path__ + "img/forest-sun.6b6d0bcc.svg";